const API_BASE = import.meta.env.VITE_DB_API_URL || '/api';

export const DB = {
  get: async (key) => {
    try {
      const res = await fetch(`${API_BASE}/storage/${encodeURIComponent(key)}`);
      if (!res.ok) return null;
      const data = await res.json();
      return data.value ?? null;
    } catch (e) {
      console.error(`DB.get error for key "${key}":`, e);
      return null;
    }
  },

  set: async (key, value) => {
    try {
      const res = await fetch(`${API_BASE}/storage/${encodeURIComponent(key)}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ value })
      });
      return res.ok;
    } catch (e) {
      console.error(`DB.set error for key "${key}":`, e);
      return false;
    }
  },

  del: async (key) => {
    try {
      const res = await fetch(`${API_BASE}/storage/${encodeURIComponent(key)}`, {
        method: 'DELETE'
      });
      return res.ok;
    } catch (e) {
      console.error(`DB.del error for key "${key}":`, e);
      return false;
    }
  }
};
